((root) => {
  const count = (value, minimum) => {
    const number = Number(value);
    if (!Number.isInteger(number) || number < minimum || number > 20) throw new Error('invalid_quantity');
    return number;
  };
  const quote = (config, selection, now = new Date()) => {
    const adults = count(selection.adults, 1), children = count(selection.children, 0), babies = count(selection.babies, 0);
    if (adults + children + babies > 20) throw new Error('invalid_quantity');
    const adult = config.variants.find(v => String(v.id) === String(selection.room) && v.category === 'adult');
    const child = config.variants.find(v => v.category === 'child');
    const baby = config.variants.find(v => v.category === 'baby');
    if (!adult || (children && !child) || (babies && !baby)) throw new Error('invalid_variant');
    const rows = [{variant: adult, quantity: adults}, ...(children ? [{variant: child, quantity: children}] : []), ...(babies ? [{variant: baby, quantity: babies}] : [])];
    if (rows.some(r => !Number.isInteger(r.variant.price) || r.variant.price < 0)) throw new Error('invalid_price');
    const total = rows.reduce((sum, r) => sum + r.variant.price * r.quantity, 0);
    const deposit = rows.reduce((sum, r) => sum + Math.round(r.variant.price * .3) * r.quantity, 0);
    const departure = Date.parse(config.departure + 'T12:00:00Z');
    const today = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
    const days = (departure - Date.parse(today + 'T12:00:00Z')) / 86400000;
    if (!Number.isFinite(days) || days < 0) throw new Error('expired');
    const allocations = rows.map(r => r.variant.allocations?.find(a => String(a.id) === String(config.depositPlanId)));
    const depositReady = days > 30 && Boolean(config.depositPlanId) && rows.every((r, i) => {
      const a = allocations[i];
      return a && a.charge === Math.round(r.variant.price * .3) && a.remaining + a.charge === r.variant.price && a.price === r.variant.price;
    });
    return {rows, total, deposit, remaining: total - deposit, depositReady, days};
  };
  const cartItems = (config, selection, now) => {
    const result = quote(config, selection, now);
    if (!config.bookingOpen || result.rows.some(r => !r.variant.available) || (Number(selection.babies) && !config.babyRuleConfirmed)) throw new Error('booking_closed');
    if (selection.payment === 'deposit' && !result.depositReady) throw new Error('deposit_unavailable');
    return result.rows.map(r => ({id: r.variant.id, quantity: r.quantity, properties: {'_cto_departure': config.departure, 'Chambre': result.rows[0].variant.title}, ...(selection.payment === 'deposit' ? {selling_plan: config.depositPlanId} : {})}));
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {quote, cartItems};
  if (!root.document) return;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-cto-trip-purchase]').forEach(element => {
      if (element.dataset.ready) return;
      element.dataset.ready = 'true';
      let config;
      try { config = JSON.parse(element.querySelector('[data-trip-config]').textContent); } catch { return; }
      const form = element.querySelector('[data-trip-form]');
      form.querySelector('[data-trip-inputs]').disabled = false;
      const error = element.querySelector('[data-trip-error]');
      const button = form.querySelector('[type=submit]');
      let pendingCheckout = false;
      window.addEventListener('pageshow', () => {
        if (!pendingCheckout) return;
        pendingCheckout = false; button.disabled = !config.bookingOpen;
        window.CTOFormUX?.release(form);
      });
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:config.currency});
      const selection = () => Object.fromEntries(new FormData(form));
      const update = () => {
        try {
          const value = quote(config, selection());
          element.querySelector('[data-trip-total]').textContent = formatter.format(value.total / 100);
          const option = form.querySelector('option[value=deposit]');
          if (option) {
            option.disabled = !value.depositReady || !config.bookingOpen;
            if (option.disabled && selection().payment === 'deposit') form.querySelector('[data-trip-payment]').value = 'full';
          }
          const payingDeposit = selection().payment === 'deposit';
          const due = config.bookingOpen && !payingDeposit ? value.total : value.deposit;
          const remaining = config.bookingOpen && !payingDeposit ? 0 : value.remaining;
          element.querySelector('[data-trip-deposit]').textContent = formatter.format(due / 100);
          element.querySelector('[data-trip-remaining]').textContent = formatter.format(remaining / 100);
          const deadline = element.querySelector('[data-trip-deadline]');
          if (deadline) deadline.hidden = !payingDeposit || !value.depositReady;
          if (config.bookingOpen) element.querySelector('[data-trip-due-label]').textContent = config.labels.due;
          error.hidden = true;
        } catch {
          error.textContent = config.labels.error; error.hidden = false;
        }
      };
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        if (!form.reportValidity()) return;
        let items;
        try { items = cartItems(config, selection()); }
        catch(e) { error.textContent = e.message === 'deposit_unavailable' ? config.labels.depositUnavailable : config.labels.unavailable; error.hidden = false; return; }
        button.disabled = true;
        pendingCheckout = true;
        window.CTOFormUX?.busy(form, window.CTOFormUX.copy.adding);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:AbortSignal.timeout(45000)});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error('cart_error');
          for (const item of items) window.CTOAnalytics?.capture('product_added_to_cart',{variant_id:String(item.id),quantity:item.quantity});
          window.CTOFormUX?.busy(form, window.CTOFormUX.copy.checkout);
          window.location.assign('/checkout');
        } catch { pendingCheckout = false; form.removeAttribute('aria-busy'); window.CTOFormUX?.feedback(form, 'error', window.CTOFormUX.copy.purchase_error).focus(); error.textContent = config.labels.error; error.hidden = false; button.disabled = false; }
      });
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})(typeof window === 'undefined' ? {} : window);

(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-trip-form]').forEach(form => {
    const origin = form.querySelector('[data-trip-origin]');
    if (!origin || origin.dataset.ready) return;
    origin.dataset.ready = 'true';
    const fields = form.querySelector('[data-trip-inputs]');
    const request = form.querySelector('[data-trip-marseille]');
    const update = () => { const asking = origin.value === 'marseille'; fields.hidden = asking; request.hidden = !asking; };
    origin.addEventListener('change', update);
    form.addEventListener('submit', event => { if (origin.value !== 'paris') { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
    update();
  });
  if (typeof document === 'undefined') return;
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
